import { createStore } from 'redux'

import rootReducer from './reducers'
import { loadState, saveState } from './localStorage'

const persistedState = loadState()
const store = createStore(
  rootReducer,
  persistedState,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
)

store.subscribe(() => {
  // saveState(store.getState())
  saveState({
    activeAudio: store.getState().activeAudio,
    // activeConversation: store.getState().activeConversation,
    availabilities: store.getState().availabilities,
    company: store.getState().company,
    // conversations: store.getState().conversations,
    expanded: store.getState().expanded,
    features: store.getState().features,
    permissions: store.getState().permissions,
    permissions_extra: store.getState().permissions_extra,
    preferences: store.getState().preferences,
    usability: store.getState().usability,
    keyword: store.getState().keyword,
    profiles: store.getState().profiles,
    roles: store.getState().roles,
    undock: store.getState().undock,
    user: store.getState().user,
    userPreferences: store.getState().userPreferences,
    ticketGallery: store.getState().ticketGallery,
    dock: store.getState().dock,
    changeStatus: store.getState().changeStatus,
    // consumerTickets: store.getState().consumerTickets,
  })
})

export default store
